export default "__VITE_ASSET__SOwvbLIq__"